import { render, staticRenderFns } from "./EcoScoreSectionItem.vue?vue&type=template&id=072a4429&scoped=true&"
import script from "./EcoScoreSectionItem.vue?vue&type=script&lang=ts&"
export * from "./EcoScoreSectionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a4429",
  null
  
)

export default component.exports